var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.887 20.135H17.6l3.722-3.722a.958.958 0 000-1.356L19.966 13.7a.958.958 0 00-1.356 0l-3.722 3.722v2.713h-.001z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.674 10.562v-4.79M11.039 16.322H5.283a1.92 1.92 0 01-1.92-1.92V5.746",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.745 3.815H5.293a1.93 1.93 0 00-1.93 1.931v0c0 .64.318 1.238.848 1.597l5.14 3.486a3.867 3.867 0 004.34 0l5.138-3.485a1.93 1.93 0 00.847-1.597v-.001a1.93 1.93 0 00-1.93-1.93z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgEmailEdit;